export default "__VITE_ASSET__vvw29SnK__"